var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3296({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1997 17.3999V12.5999H16.7997L11.9997 6.59985L7.19971 12.5999H10.7997V17.3999H13.1997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.3999H8.4V14.9999H6C4.0152 14.9999 2.4 13.3847 2.4 11.3999C2.4 9.71505 3.8388 8.09265 5.6076 7.78185L6.3048 7.65945L6.5352 6.98985C7.3788 4.52865 9.474 2.99985 12 2.99985C15.3084 2.99985 18 5.69145 18 8.99985V10.1999H19.2C20.5236 10.1999 21.6 11.2763 21.6 12.5999C21.6 13.9235 20.5236 14.9999 19.2 14.9999H15.6V17.3999H19.2C21.8472 17.3999 24 15.2471 24 12.5999C23.9982 11.5242 23.636 10.4801 22.9712 9.63445C22.3065 8.78875 21.3776 8.19016 20.3328 7.93425C19.8084 3.80385 16.272 0.599854 12 0.599854C8.6928 0.599854 5.82 2.53305 4.5084 5.57985C1.9308 6.35025 0 8.78385 0 11.3999C0 14.7083 2.6916 17.3999 6 17.3999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3296);
export default __webpack_public_path__ + "static/media/Group 3296.8be0b60037a597a5207c1ea44e54023b.svg";
export { ForwardRef as ReactComponent };